import { MatDialog } from '@angular/material/dialog';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { ModalService } from '../../services/modal.service';
import { DateTime } from 'luxon';
import { SessionTimeoutState } from '../enums/SessionTimeoutState';

@Injectable({   
  providedIn: 'root'
})
export class SessionTimeoutService {

  private static readonly checkInterval = 30  * 1000; // check every 30 seconds if a modal is needed - in ms
  private static readonly warningInterval = 2; // warn 2 minutes before expiry with modal - actual modal countdown is 60 seconds, but it doesn't really matter, and this gives us a little buffer
  private static readonly sessionRefreshInterval = 5; // refresh 5 minutes before expiry - used by interceptor, etc. to refresh on api calls
  
  private  subscription: Subscription | undefined


  constructor(private authService: AuthService, private dialog: MatDialog, private modalService : ModalService) {}


  startSessionCheck(){
    this.subscription = interval(SessionTimeoutService.checkInterval).subscribe(() => {
      this.checkSession();
    });
  }

  stopSessionCheck(){
    if(this.subscription)
      this.subscription.unsubscribe();
  }

  public  getSessionState(): SessionTimeoutState {
      const expires = this.authService.expires;
      if (expires == null) {
        return SessionTimeoutState.Expired;
      }
    const expiresDateTime = DateTime.fromISO(expires);

    if(expiresDateTime <= DateTime.now()){
      return SessionTimeoutState.Expired;
    }
    if(expiresDateTime.diffNow('minutes').minutes <= SessionTimeoutService.warningInterval){
      return SessionTimeoutState.ExpiringSoon;
    }
    if(expiresDateTime.diffNow('minutes').minutes <= SessionTimeoutService.sessionRefreshInterval){
      return SessionTimeoutState.ExpiringRefreshInBackground;
    }
    return SessionTimeoutState.Fine;    

  }

  checkSession(){
    const sessionState = this.getSessionState();
    if(sessionState == SessionTimeoutState.ExpiringSoon){
      this.modalService.showSessionTimeoutWarning();
    }
  }



} 
      